import { Expose } from "class-transformer";

export default class CarRes {
  @Expose() readonly carType!: string;
  @Expose() readonly carColor!: string;
  @Expose() readonly carNumber!: string;
}
